import { ComponentType } from 'react';
import { oidcConfig } from '@common/auth/useOidcAuthentication';
import { AuthProvider } from 'react-oidc-context';
import { useGetAuthConfig } from '@common/hooks/useGetAuthConfig';
import { PleaseWaitOverlay } from '@common/components/PleaseWaitOverlay/PleaseWaitOverlay';

export const WithAuthProvider = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const WithAuthProvider = (props: P) => {
    const { authConfig, isGettingAuthConfig } = useGetAuthConfig();

    return isGettingAuthConfig ? (
      <PleaseWaitOverlay />
    ) : (
      <AuthProvider {...authConfig} {...oidcConfig}>
        <WrappedComponent {...props} />
      </AuthProvider>
    );
  };

  return WithAuthProvider;
};
